import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Item, Anchor } from "../../components/elements";
import { CardLayout, CardHeader, FloatCard } from "../../components/cards";
import { Breadcrumb, Pagination } from "../../components";
import OrdersTable from "../../components/tables/OrdersTable";
import LabelField from "../../components/fields/LabelField";
import PageLayout from "../../layouts/PageLayout";
import data from "../../data/master/orderList.json";
import { useDispatch, useSelector } from "react-redux";
import { getOrdersList } from "../../store/ordersListSlice";
import { getOrderCounter } from "../../store/orderCounterSlice";


export default function OrderList() {
  const {ordersList} = useSelector((state)=>state.ordersList);
  const {orderCounter,isLoading} = useSelector((state)=>state.orderCounter)

  const dispatch = useDispatch();
console.log(orderCounter);


  useEffect(()=>{
    dispatch(getOrdersList())
    dispatch(getOrderCounter())
    // dispatch(getCategory())
  },[dispatch])
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <CardLayout>
            <Breadcrumb title={data?.pageTitle}>
              {data?.breadcrumb.map((item, index) => (
                <Item key={index} className="mc-breadcrumb-item">
                  {item.path ? (
                    <Anchor className="mc-breadcrumb-link" href={item.path}>
                      {item.text}
                    </Anchor>
                  ) : (
                    item.text
                  )}
                </Item>
              ))}
            </Breadcrumb>
          </CardLayout>
        </Col>
          <Col  xl={3}>
            <FloatCard
              variant="lg purple"
              digit={orderCounter.OfferStatus && orderCounter.OfferStatus.TotalOffers}
              title="Total Offer"
              icon="shopping_bag"
            />
          </Col>
          <Col  xl={3}>
            <FloatCard
              variant="lg green"
              digit={orderCounter.OfferStatus && orderCounter.OfferStatus.Approved}
              title="Approved"
              icon="shopping_bag"
            />
          </Col>
          <Col  xl={3}>
            <FloatCard
              variant="lg yellow"
              digit={orderCounter.OfferStatus && orderCounter.OfferStatus.Pending}
              title="Pending"
              icon="pending"
            />
          </Col>
          <Col  xl={3}>
            <FloatCard
              variant="lg blue"
              digit={orderCounter.OfferStatus && orderCounter.OfferStatus.Processing}
              title="Processing"
              icon="shopping_bag"
            />
          </Col>
          <Col  xl={3}>
            <FloatCard
              variant="lg yellow"
              digit={orderCounter.OfferStatus && orderCounter.OfferStatus.Shipping}
              title="Shipping"
              icon="local_shipping"
            />
          </Col>
          <Col  xl={3}>
            <FloatCard
              variant="lg red"
              digit={orderCounter.OfferStatus && orderCounter.OfferStatus.Rejected}
              title="Rejected"
              icon="remove_circle"
            />
          </Col>
        {/* {data?.float.map((item, index) => (
          <Col key={index} xl={3}>
            <FloatCard
              variant={item.variant}
              digit={item.digit}
              title={item.title}
              icon={item.icon}
            />
          </Col>
        ))} */}
        <Col xl={12}>
          <CardLayout>
            <CardHeader title="order information" dotsMenu={data?.dotsMenu} />
            {/* <Row xs={1} sm={4} className="mb-4">
              {data?.filter.map((item, index) => (
                <Col key={index}>
                  <LabelField
                    type={item.type}
                    label={item.label}
                    option={item.option}
                    placeholder={item.placeholder}
                    labelDir="label-col"
                    fieldSize="w-100 h-md"
                  />
                </Col>
              ))}
            </Row> */}
            <OrdersTable
              thead={data?.table.thead}
              tbody={ordersList}
            />
            {/* <Pagination /> */}
          </CardLayout>
        </Col>
      </Row>
    </PageLayout>
  );
}
